import { AppModule } from './app.module';

import { bootstrapAppModule } from 'Angular/utils/app-bootstrapping';

bootstrapAppModule(AppModule);
